import React from 'react';
import { cn } from '@/utils/cn';
import Button from '../../Button';
import Icon from '../../Icon';
import TextSmall from '../../Typography/TextSmall';

function FilterButton({ onFilter = () => {}, className = '' }) {
  return (
    <Button
      type="outline"
      className={cn(
        '!h-[32px] lg:!h-[40px] flex justify-center items-center gap-[4px] bg-white py-4 !px-12 lg:!px-12 border !border-himalayan-poppy rounded-[100px] focus:!border-2',
        className,
      )}
      onClick={onFilter}
    >
      <Icon type="filter" className="size-[24px] lg:size-[24px]" />

      <TextSmall
        text="Filter"
        className="text-senate text-center lg:leading-5 font-semibold"
      />
    </Button>
  );
}

export default FilterButton;
